﻿import React from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';

import { EpiContext } from '../Shared/Scripts/Store/EpiContext/Types';
import { FeilmeldingComponent } from '../Shared/Scripts/Components/FeilmeldingComponent';
import contentResolver, { resolveRawText } from '../Shared/Scripts/Utilities/EpiContentResolver';
import RadioButtonsStegContainer from '../Shared/Scripts/Components/RadioButtonsStegComponent';
import CustomRadioButtonsStegComponent from './Components/CustomRadioButtonsStegComponent';
import Valg from '../Shared/Scripts/Models/Valg';

import AAvstandValg from './Utilities/A-AvstandValg';
import BReisetidValg from './Utilities/B-ReisetidValg';
import VeilederBsDto from './Models/VeilederBsDto';
import { VeilederBsAppState } from './Store';
import * as Ids from './Ids';
import * as ValgTypes from './Store/Valg/Types';
import { updateValg, updateVisning } from './Store/Valg/Actions';
import ResultatContainer from './Components/ResultatComponent';
import { ResultatValg } from './Store/Resultat/Types';
import ModalKlikkContainer from './Components/ModalKlikkComponent';
import { Satser } from './Utilities/BorteboerstipendApi';
import { registerAnalyticsEvent } from '../Shared/Scripts/Utilities/Analytics';
import { Spinner } from '@lanekassen/ds-react';

interface AppOwnProps {}

type AppProps = AppOwnProps & MapStateToProps & MapDispatchToProps;

const RadioButtonsStegComponent = RadioButtonsStegContainer<VeilederBsDto>();

const container = document.getElementById(Ids.AppContainerId)!;
ReactModal.setAppElement(container);

const analyticsState = { startet: false, fullfort: false };
const eventId = container.parentElement!.getAttribute('data-eventid');

export class App extends React.Component<AppProps> {
    constructor(props: AppProps) {
        super(props);
    }

    render(): JSX.Element {
        const { valg, resultat, dispatchUpdateValg, epiContext, satser } = this.props;
        const { epiModel, valuta } = this.props.epiContext;

        if (epiContext.epiModelFeilet || resultat.visGenerellFeil) {
            return <FeilmeldingComponent />;
        }

        function registerEvents(): void {
            if (!analyticsState.startet) {
                if (valg.aAvstand != undefined) {
                    analyticsState.startet = true;
                    registerAnalyticsEvent({ action: 'VeilederStart', eventId });
                }
            }

            if (!analyticsState.fullfort) {
                if (resultat.visResultatKanFa || resultat.visResultatKanFaLangReisevei || resultat.visResultatKanKanskjeFa) {
                    analyticsState.fullfort = true;
                    registerAnalyticsEvent({ action: 'VeilederFerdig', eventId });
                }
            }
        }

        if (epiModel != null && satser !== null) {
            const stipendBelop: JSX.Element = (
                <div className="c-veileder__content-section">
                    <div>{contentResolver(epiContext, 'dekorasjonForBelopAvstand')}</div>
                    <div className="c-veileder__resultat-tekst">
                        {Math.round(satser === undefined || satser === null ? 0 : satser.ST01_MaksBostipendManed)}{' '}
                        <span className="c-veileder__tekst--postfix">
                            {valuta}
                        </span>
                    </div>
                    <div>{contentResolver(epiContext, 'dekorasjonEtterBelopAvstand')}</div>
                </div>
            );

            const modalKlikkRad: JSX.Element = (
                <ModalKlikkContainer
                    valg={valg}
                    lenketekst={contentResolver(epiContext, 'lenketekstAvstandModal')}
                    overskrift={contentResolver(epiContext, 'overskriftAvstandModal')}
                    content={contentResolver(epiContext, 'contentAvstandModal')}
                    ariaLabel={resolveRawText(epiContext, 'ariaLabelAvstandModal')}
                    eventId={eventId}
                />
            );

            return (
                <div className="c-veileder">
                    {registerEvents()}
                    <CustomRadioButtonsStegComponent
                        sporsmalId={Ids.BoksA}
                        tittel={contentResolver(epiContext, 'tittelAvstand')}
                        forklaring={contentResolver(epiContext, 'infoAvstand')}
                        stipendBelop={stipendBelop}
                        sporsmal="ledetekstAvstand"
                        valg={AAvstandValg.aValg}
                        onInputChange={(nyttValg: Valg<string>): void => {
                            dispatchUpdateValg({ aAvstand: nyttValg });
                        }}
                        neverCollapse={true}
                        value={valg.aAvstand}
                        customBottomRow={modalKlikkRad}
                    />
                    {resultat.visBoksB && (
                        <RadioButtonsStegComponent
                            sporsmalId={Ids.BoksB}
                            tittel={contentResolver(epiContext, 'tittelReisetid')}
                            forklaring={
                                <div>
                                    <p>{contentResolver(epiContext, 'infoReisetid')}</p>
                                </div>
                            }
                            sporsmal="ledetekstReisetid"
                            valg={BReisetidValg.bValg}
                            onInputChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({ bReisetid: nyttValg });
                            }}
                            value={valg.bReisetid}
                        />
                    )}
                    {resultat.visResultatKanFa && (
                        <ResultatContainer
                            tittel={contentResolver(epiContext, 'tittelResultatKanFa')}
                            sekundartittel={contentResolver(epiContext, 'sekundartittelResultatKanFa')}
                            info={contentResolver(epiContext, 'infoResultatKanFa')}
                            lenketekst={contentResolver(epiContext, 'lenketekstResultatKanFaModal')}
                            overskriftModal={contentResolver(epiContext, 'overskriftResultatKanFaModal')}
                            contentModal={contentResolver(epiContext, 'contentResultatKanFaModal')}
                            ariaLabelModal={resolveRawText(epiContext, 'ariaLabelResultatKanFaModal')}
                            eventId={eventId}
                        />
                    )}
                    {resultat.visResultatKanFaLangReisevei && (
                        <ResultatContainer
                            tittel={contentResolver(epiContext, 'tittelResultatKanFaLangReisevei')}
                            sekundartittel={contentResolver(epiContext, 'sekundartittelResultatKanFaLangReisevei')}
                            info={contentResolver(epiContext, 'infoResultatKanFaLangReisevei')}
                            lenketekst={contentResolver(epiContext, 'lenketekstResultatKanFaLangReiseveiModal')}
                            overskriftModal={contentResolver(epiContext, 'overskriftResultatKanFaLangReiseveiModal')}
                            contentModal={contentResolver(epiContext, 'contentResultatKanFaLangReiseveiModal')}
                            ariaLabelModal={resolveRawText(epiContext, 'ariaLabelResultatKanFaLangReiseveiModal')}
                            eventId={eventId}
                        />
                    )}
                    {resultat.visResultatKanKanskjeFa && (
                        <ResultatContainer
                            tittel={contentResolver(epiContext, 'tittelResultatKanKanskjeFa')}
                            sekundartittel={contentResolver(epiContext, 'sekundartittelResultatKanKanskjeFa')}
                            info={contentResolver(epiContext, 'infoResultatKanKanskjeFa')}
                            lenketekst={contentResolver(epiContext, 'lenketekstResultatKanKanskjeFaModal')}
                            overskriftModal={contentResolver(epiContext, 'overskriftResultatKanKanskjeFaModal')}
                            contentModal={contentResolver(epiContext, 'contentResultatKanKanskjeFaModal')}
                            ariaLabelModal={resolveRawText(epiContext, 'ariaLabelResultatKanKanskjeFaModal')}
                            eventId={eventId}
                        />
                    )}
                </div>
            );
        } else {
            return <Spinner aria-label='Laster...' />;
        }
    }
}

interface MapStateToProps {
    valg: ValgTypes.ValgState;
    epiContext: EpiContext<VeilederBsDto>;
    resultat: ResultatValg;
    satser: Satser | null;
}

interface MapDispatchToProps {
    dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>) => void;
}

const mapDispatchToProps = (dispatch: ThunkDispatch<VeilederBsAppState, {}, AnyAction>): MapDispatchToProps => ({
    dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>): void => {
        dispatch(updateValg(newValg));
        dispatch(updateVisning());
    },
});

const mapStateToProps = (state: VeilederBsAppState): MapStateToProps => ({
    valg: state.valg,
    epiContext: state.epiContext,
    resultat: state.resultat,
    satser: state.satser
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
